<div class="welcome-page">
  <!-- Welcome hero -->
  <section class="welcome-hero">
    <div class="welcome-hero-content">
      <h1 class="welcome-title">
        Welcome back<span *ngIf="currentUser$">, {{ currentUser$?.firstName   }}</span>
      </h1>
      <p class="welcome-subtitle">Here’s a quick overview of important resources and how things work.</p>
    </div>
  </section>

  <!-- Important documents -->
  <section class="section">
    <h2 class="section-title">
      <i class="pi pi-folder-open section-icon"></i>
      Important documents
    </h2>
    <div class="grid grid-cols-12 gap-4">
      <ng-container *ngFor="let doc of documents">
        <div class="col-span-12 sm:col-span-6 lg:col-span-3">
          @if (doc.link) {
            <a [routerLink]="[doc.link]" class="doc-card doc-card--link">
              <div class="doc-card-icon" [attr.data-color]="doc.color">
                <i class="pi {{ doc.icon }}"></i>
              </div>
              <h3 class="doc-card-title">{{ doc.title }}</h3>
              <p class="doc-card-desc">{{ doc.description }}</p>
            </a>
          } @else {
            <div class="doc-card">
              <div class="doc-card-icon" [attr.data-color]="doc.color">
                <i class="pi {{ doc.icon }}"></i>
              </div>
              <h3 class="doc-card-title">{{ doc.title }}</h3>
              <p class="doc-card-desc">{{ doc.description }}</p>
            </div>
          }
        </div>
      </ng-container>
    </div>
  </section>

  <!-- Business flows -->
  <section class="section">
    <h2 class="section-title">
      <i class="pi pi-sitemap section-icon"></i>
      Business flows
    </h2>
    <div class="flow-container">
      <div class="flow-steps">
        <a *ngFor="let step of flowSteps; let last = last" [routerLink]="[step.path]" class="flow-step">
          <div class="flow-step-icon">
            <i class="pi {{ step.icon }}"></i>
          </div>
          <span class="flow-step-label">{{ step.label }}</span>
          <span *ngIf="!last" class="flow-step-arrow" aria-hidden="true">
            <i class="pi pi-arrow-right"></i>
          </span>
        </a>
      </div>
    </div>
    <p class="flow-hint">Click any step to go to that module.</p>
  </section>
</div>
